import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-campaign-reached-apply-limit-page',
  templateUrl: './campaign-reached-apply-limit-page.component.html',
  styleUrls: ['./campaign-reached-apply-limit-page.component.scss']
})
export class CampaignReachedApplyLimitPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
